export const SECONDS_TITLE = 'Seconds';
export const MINUTES_TITLE = 'Minutes';
export const HOURS_TITLE = 'Hours';
export const DAYS_TITLE = 'Days';
export const DEFAULT_INTERVAL_MS = 1000;
